export default "__VITE_ASSET__BUtMfMt1__"